<script>
import { Bubble, mixins } from "vue-chartjs";
import _ from "lodash";
import util from "util";
const { reactiveProp } = mixins;
export default {
  name: "chartjs-bubble",
  extends: Bubble,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  updated() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  watch: {
    chartData: {
      handler() {
        this.$data._chart.destroy();
        this.renderChart(this.chartData, this.chartOptions);
        // this.$data._chart.update();
      },
    },
  },
};
</script>